export default __webpack_public_path__ + "d93481e0050d808a95afd9e1e65f54f7.svg";